import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Dipendente } from 'src/app/models/dipendente';
import { FormDipendenteComponent } from 'src/app/shared/components/form/form-dipendente/form-dipendente.component';
import { GridScadenzeDipendentiComponent } from 'src/app/shared/components/grid/grid-scadenze-dipendenti/grid-scadenze-dipendenti.component';
import { AlertService } from 'src/app/shared/services/alert.service';
import { DipendentiService } from 'src/app/shared/services/dipendenti.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';
import { GridConsegneComponent } from 'src/app/shared/components/grid/grid-consegne/grid-consegne.component';
import { GestioneArticoliPrevistiComponent } from 'src/app/shared/components/dipendenti/gestione-articoli-previsti/gestione-articoli-previsti.component';
import { ArticoliConsegnatiComponent } from 'src/app/shared/components/articoli/articoli-consegnati/articoli-consegnati.component';
import { GridAllegatiDipendenteComponent } from 'src/app/shared/components/grid/grid-allegati-dipendente/grid-allegati-dipendente.component';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-dipendenti-details',
  templateUrl: './dipendenti-details.component.html',
  styleUrls: ['./dipendenti-details.component.scss'],
  imports: [
    FormDipendenteComponent,
    GridScadenzeDipendentiComponent,
    GridConsegneComponent,
    GestioneArticoliPrevistiComponent,
    ArticoliConsegnatiComponent,
    GridAllegatiDipendenteComponent,
  ],
  standalone: true,
})
export class DipendentiDetailsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private nS = inject(NavigatorService);
  private dipendentiS = inject(DipendentiService);
  private alertS = inject(AlertService);

  idDipendente: number;
  idCatArticolo: number;
  dipendente: Dipendente;
  reloadDataBs = new BehaviorSubject<boolean>(true);
  activeTab = 'dettaglio-dip';

  ngOnInit() {
    const idDipendenteParam = this.route.snapshot.paramMap.get('idDipendente');
    if (idDipendenteParam == null || idDipendenteParam == '0') {
      this.nS.goToHome();
    }
    this.idDipendente = +idDipendenteParam;
    this.idCatArticolo = 0;

    //Dettaglio pratica
    this.getDipendente(this.idDipendente);

    const tab = this.route.snapshot.paramMap.get('tab');
    if (tab != null && tab.length > 0) {
      this.changeTab(tab);
    }
  }

  changeTab(actTab) {
    this.activeTab = actTab;
  }

  /**
   * Dettaglio del dipendente
   * @param idDipendente
   */
  getDipendente(idDipendente: number) {
    this.dipendentiS.get(idDipendente).subscribe({
      next: (dati) => {
        this.dipendente = dati;
      },
      error: (error) => {
        if (error?.status == 500 && error?.error?.title) {
          notify(error?.error?.title, 'warning');
        } else {
          notify('Errore caricamento dati dipendente', 'warning');
        }
      },
    });
  }

  goToDipendenti() {
    this.nS.goToDipendenti();
  }

  onDataDipendenteEvent(event) {
    this.reloadDataBs.next(event);
  }
}
